import { Moment } from 'moment';
export function objToQueryString(obj) {
  return Object.keys(obj).map(key => key + '=' + obj[key]).join('&');
}

export function generateKey(total) {
  return Math.random().toString(36).substring(total);
}

export function getFileName(filename: string) {
  return filename.substring(0, filename.lastIndexOf('.'));
}

export function getFileExtension(filename: string) {
  return filename.substring(filename.lastIndexOf('.') + 1);
}


export function convertToUtcTime(date: Moment): Moment {
  const offset = date.utcOffset();
  const utcdate = date.utc();
  return utcdate.add(offset, 'm');
}

/**
 * Remove element from indexed object
 * @param data object
 * @param index index of element to remove
 * */
export function removeObjElement(data, index: number) {
  if (data && data[index]) {
    const { [index]: undefined, ...dtt } = data;
    return dtt;
  }
  return data;
}

export function getAudioDuration(blob: Blob) {
  return new Promise((resolve) => {
    const audio = new Audio();
    audio.onloadedmetadata = () => {
      resolve(audio.duration);
    };
    audio.src = URL.createObjectURL(blob);
  });
}
